import React, { Dispatch, SetStateAction, useState } from 'react';
import styles from './propertyReport.module.css';
import iconClose from '../../images/icon-close.svg';
import { AnyIfEmpty } from 'react-redux';
import { Availability } from './propertyReport';
import moment from 'moment';

const AvailabilityPopup = ({ setShowAvailabilityModal, showAvailabilityModal, modalContent }: AnyIfEmpty<object>) => {
    const closeModal = () => setShowAvailabilityModal(!showAvailabilityModal);

    return (
        <div className={`${styles.availabilityPopup} availabilityPopup event-info`}>
            <div className={styles.modalHeader}>
                <h2 className={styles.modalTitle}>Availability Details</h2>
                <span className={styles.close}>
                    <img src={iconClose} onClick={closeModal} alt="Close" />
                </span>
            </div>
            <div className={`${styles.availabilityPopupBody} customScrollbar`}>
                <table className={styles.availabilityTable}>
                    <thead>
                        <tr>
                            <th>Start Date</th>
                            <th>end Date</th>
                            <th>Opening Hours</th>
                            <th>closing Hours</th>
                            <th>Locker</th>
                        </tr>
                    </thead>
                    <tbody>
                        {modalContent?.map((val: Availability) =>
                            <tr key={val.availabilityId}>
                                <td>{val.startDate}</td>
                                <td>{val.endDate}</td>
                                <td>{moment(val.openTime, 'HH:mm').format('hh:mm A')}</td>
                                <td>{moment(val.closeTime, 'HH:mm').format('hh:mm A')}</td>
                                <td>{val.locker}</td>
                            </tr>)}
                    </tbody>
                </table>

                {!modalContent?.length && <div className={styles.noAvailabilityWrapper}>
                    <p>No availability added</p>
                </div>}
            </div>
        </div>
    );
};

export default AvailabilityPopup;
